<template>
  <svg
    id="svg4"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style="fill: none"
  >
    <path
      id="path2"
      d="m 0.63157868,8.0000026 c 0,-4.0694675 3.29895732,-7.36842392 7.36842282,-7.36842392 4.0694775,0 7.3684195,3.29895642 7.3684195,7.36842392 0,4.0694804 -3.298942,7.3684104 -7.3684195,7.3684104 -4.0694655,0 -7.36842282,-3.29893 -7.36842282,-7.3684104 z"
      style="fill: #3ca091; stroke: #3ca091; stroke-width: 1.26315737"
    />
    <circle
      id="path817"
      style="fill: #ffffff; fill-opacity: 1; stroke: none; stroke-opacity: 1"
      cx="8"
      cy="7.9999957"
      r="4"
    />
  </svg>
</template>

<script>
export default {
  name: 'RadioOn'
};
</script>

<style scoped>

</style>
